import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';

//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { FooterComponent } from './common/footer/footer.component';
import { IssuesComponent } from './issues/issues.component';
// import { IssueDetailsComponent } from './Issues/issue-details/issue-details.component';
import { IssueMenuComponent } from './Issues/issue-menu/issue-menu.component';
import { IssuesGridComponent } from './issues/issues-grid/issues-grid.component';
import { MasterMenuComponent } from './masters/master-menu/master-menu.component';
import { MastersComponent } from './masters/masters.component';
import { CompanyGridComponent } from './masters/company/company-grid/company-grid.component';
import { CompanyFormComponent } from './masters/company/company-form/company-form.component';
import { ProjectFormComponent } from './masters/project/project-form/project-form.component';
import { ProjectGridComponent } from './masters/project/project-grid/project-grid.component';
import { ClientFromComponent } from './client/client-from/client-from.component';
import { ClientGridComponent } from './client/client-grid/client-grid.component';
import { InternalComponent } from './issues/internal/internal.component';
import { InternalGridComponent } from './issues/internal/internal-grid/internal-grid.component';
import { InternalFormComponent } from './issues/internal/internal-form/internal-form.component';
import { ExternalIssuesGridComponent } from './issues/external-issues-grid/external-issues-grid.component';
import { ExternalIssuesDetailsComponent } from './issues/external-issues-details/external-issues-details.component';
import { ExternalIssuesFormComponent } from './issues/external-issues-form/external-issues-form.component';
import { IssueAlertGridComponent } from './issues/issue-alert-grid/issue-alert-grid.component';
import { IssueAlertUpdateComponent } from './issues/issue-alert-update/issue-alert-update.component';
import { IssueDetailedViewComponent } from './issues/issue-detailed-view/issue-detailed-view.component';


import { ProspectComponent } from './prospect/prospect.component';
import { TelecallerComponent } from './prospect/telecaller/telecaller.component';
import { UnifyMarketingComponent } from './prospect/unify-marketing/unify-marketing.component';
import { UnifyMarketingFormComponent } from './prospect/unify-marketing/unify-marketing-form/unify-marketing-form.component';
import { UnifyMarketingGridComponent } from './prospect/unify-marketing/unify-marketing-grid/unify-marketing-grid.component';
import { ProspectMenuComponent } from './prospect/prospect-menu/prospect-menu.component';
import { TelecallerGridComponent } from './prospect/telecaller/telecaller-grid/telecaller-grid.component';
import { TelecallerFormComponent } from './prospect/telecaller/telecaller-form/telecaller-form.component';
import { UnifyMarketingNoteComponent } from './prospect/unify-marketing/unify-marketing-note/unify-marketing-note.component';
import { ReportsComponent } from './reports/reports.component';
import { TodaysTicketsComponent } from './reports/todays-tickets/todays-tickets.component';
import { TodaysUnassignedTicketsComponent } from './reports/todays-unassigned-tickets/todays-unassigned-tickets.component';
import { TodaysOpenedTicketsComponent } from './reports/todays-opened-tickets/todays-opened-tickets.component';
import { TodaysClosedTicketsComponent } from './reports/todays-closed-tickets/todays-closed-tickets.component';
import { TodaysOpenUnresolvedTicketsComponent } from './reports/todays-open-unresolved-tickets/todays-open-unresolved-tickets.component';
import { AllUnassignedTicketsComponent } from './reports/all-unassigned-tickets/all-unassigned-tickets.component';
import { AllOpenedTicketsComponent } from './reports/all-opened-tickets/all-opened-tickets.component';
import { AllClosedTicketsComponent } from './reports/all-closed-tickets/all-closed-tickets.component';
import { ExpectedDatewiseAllTicketCountComponent } from './reports/expected-datewise-all-ticket-count/expected-datewise-all-ticket-count.component';
import { OverdueReportsComponent } from './reports/overdue-reports/overdue-reports.component';
import { ClientOpenNclosedTicketCountComponent } from './reports/client-open-nclosed-ticket-count/client-open-nclosed-ticket-count.component';
import { ProjectwiseClientListComponent } from './reports/projectwise-client-list/projectwise-client-list.component';
import { ClientHighestTicketsComponent } from './reports/client-highest-tickets/client-highest-tickets.component';
import { ClientLowestTicketsComponent } from './reports/client-lowest-tickets/client-lowest-tickets.component';
import { ClientsCountForProjectsComponent } from './reports/clients-count-for-projects/clients-count-for-projects.component';
import { PriorityIssueComponent } from './reports/priority-issue/priority-issue.component';
import { ReportMenuComponent } from './reports/report-menu/report-menu.component';
import { TelecallerDetailsComponent } from './prospect/telecaller-details/telecaller-details.component';
import { UnifyMarketingDetailsGridComponent } from './prospect/unify-marketing-details/unify-marketing-details-grid/unify-marketing-details-grid.component';
import { UnifyMarketingDetailsFormComponent } from './prospect/unify-marketing-details/unify-marketing-details-form/unify-marketing-details-form.component';
import { TelecallerDetailsFormComponent } from './prospect/telecaller-details/telecaller-details-form/telecaller-details-form.component';
import { TelecallerDetailsGridComponent } from './prospect/telecaller-details/telecaller-details-grid/telecaller-details-grid.component';
import { UnifyMarketingDetailsComponent } from './prospect/unify-marketing-details/unify-marketing-details.component';
import { TelecallerViewComponent } from './prospect/telecaller/telecaller-view/telecaller-view.component';
import { ClientsComponent } from './masters/clients/clients.component';
import { ClientsGridComponent } from './masters/clients/clients-grid/clients-grid.component';
import { ClientsFormComponent } from './masters/clients/clients-form/clients-form.component';
import { InternalUsersGridComponent } from './masters/internal-users/internal-users-grid/internal-users-grid.component';
import { InternalUsersFormComponent } from './masters/internal-users/internal-users-form/internal-users-form.component';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EmployeewiseClosedTicketsComponent } from './reports/employeewise-closed-tickets/employeewise-closed-tickets.component';
import { EmployeewisePendingTicketsComponent } from './reports/employeewise-pending-tickets/employeewise-pending-tickets.component';
import { OverallreportComponent } from './reports/overallreport/overallreport.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    FooterComponent,
    IssuesComponent,
    // IssueDetailsComponent,
    IssueMenuComponent,
    IssuesGridComponent,
    MasterMenuComponent, 
    MastersComponent, 
    CompanyGridComponent,
    CompanyFormComponent,
    ProjectFormComponent,
    ProjectGridComponent,
    ClientFromComponent,
    ClientGridComponent,
    InternalComponent,
    InternalGridComponent,
    ExternalIssuesGridComponent,
    ExternalIssuesDetailsComponent,
    ExternalIssuesFormComponent,
    IssueAlertGridComponent,
    IssueAlertUpdateComponent,
    IssueDetailedViewComponent,
    
  
    ProspectComponent,
    TelecallerComponent,
    TelecallerGridComponent,
    TelecallerFormComponent,
    UnifyMarketingComponent,
    UnifyMarketingFormComponent,
    UnifyMarketingGridComponent,
    ProspectMenuComponent,
    UnifyMarketingNoteComponent,
    ReportsComponent,
    TodaysTicketsComponent,
    TodaysUnassignedTicketsComponent,
    TodaysOpenedTicketsComponent,
    TodaysClosedTicketsComponent,
    TodaysOpenUnresolvedTicketsComponent,
    AllUnassignedTicketsComponent,
    AllOpenedTicketsComponent,
    AllClosedTicketsComponent,
    ExpectedDatewiseAllTicketCountComponent,
    OverdueReportsComponent,
    ClientOpenNclosedTicketCountComponent,
    ProjectwiseClientListComponent,
    ClientHighestTicketsComponent,
    ClientLowestTicketsComponent,
    ClientsCountForProjectsComponent,
    PriorityIssueComponent,
    ReportMenuComponent,
    TelecallerDetailsComponent,
    UnifyMarketingDetailsGridComponent,
    UnifyMarketingDetailsFormComponent,
    TelecallerDetailsFormComponent,
    TelecallerDetailsGridComponent,
    UnifyMarketingDetailsComponent,
    TelecallerViewComponent,
    ClientsComponent,
    ClientsGridComponent ,
    ClientsFormComponent,
    InternalUsersGridComponent,
    InternalUsersFormComponent,
    EmployeewiseClosedTicketsComponent,
    EmployeewisePendingTicketsComponent,
    OverallreportComponent
  ],
  imports: [
    // NumericTextBoxModule,
    NgMultiSelectDropDownModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [UserService,DatePipe, ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass:AuthInterceptor,
  //   multi:true
  // }
],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts